import React from 'react';

export default function Loading () {
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>
                                Loading...
                            </h2>
                        </div>
                        <div className="ibox-content">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
